import { useState, useEffect, useCallback } from 'react';
import * as api from 'app/api';
import { isServer } from 'app/libs/environment';

function useNow(options = {}) {
	const { lazy = true } = options;
	const [now, setNow] = useState(isServer ? new Date() : undefined);

	const getNow = useCallback(async () => {
		if (isServer) return new Date();

		try {
			const { data: nowDateTime } = await api.getNow({ timeout: 2000 });
			return new Date(nowDateTime);
		} catch (error) {
			console.log('Error get now datetime', error);
			return new Date();
		}
	}, []);

	useEffect(() => {
		if (!lazy) {
			getNow().then(setNow);
		}
	}, [lazy, getNow]);

	return { now, getNow };
}

export default useNow;
